import * as React from "react";
import { Stack, Typography } from "@mui/material";
import AdvancedQueryTag, { AdvancedQueryTagProps } from "../AdvancedQueryTag/advanced-query-tag";

export interface AdvancedQueriesProps {
  queries: ({ operator: string } | { parenthesis: string } | AdvancedQueryTagProps)[];
  withWrapper?: boolean;
}

const AdvancedQueries: React.FC<AdvancedQueriesProps> = (props) => {
  const { withWrapper = true, queries } = props;
  const _query = React.useMemo(
    () =>
      queries.map((query, index) =>
        "start" in query ? (
          <AdvancedQueryTag key={index} {...query} sx={{ mb: 0.5, mr: 0.25, ml: 0.25 }} />
        ) : "operator" in query ? (
          <Typography key={index} variant="h6" color="text.tier" sx={{ mb: 0.5, mr: 0.25, ml: 0.25 }}>
            {query.operator}
          </Typography>
        ) : (
          <Typography key={index} color="text.primary" sx={{ mb: 0.5, mr: 0.25, ml: 0.25 }}>
            {query.parenthesis}
          </Typography>
        )
      ),
    [queries]
  );
  if (withWrapper) {
    return (
      <Stack display="inline-flex" direction="row" alignItems="center" flexWrap="wrap">
        {_query}
      </Stack>
    );
  }
  return <>{_query}</>;
};

export default AdvancedQueries;
